const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign']
const COOKIE_EXPIRY_DAYS = 30

const isPaidTraffic = url => {
  const paidParams = ['gclid', 'gbraid', 'wbraid', 'fbclid']
  return paidParams.some(param => url.searchParams.has(param))
}

const detectSource = referrer => {
  if (!referrer) return { source: 'direct', medium: 'none' }

  const host = new URL(referrer).hostname

  const socialMap = {
    'facebook.com': 'facebook',
    'fb.com': 'facebook',
    'l.facebook.com': 'facebook',
    'm.facebook.com': 'facebook',
    'instagram.com': 'instagram',
    'tiktok.com': 'tiktok',
    'linkedin.com': 'linkedin',
    'x.com': 'twitter',
    't.co': 'twitter',
    'twitter.com': 'twitter',
    'pinterest.com': 'pinterest',
    't.me': 'telegram',
    'telegram.org': 'telegram',
    'reddit.com': 'reddit',
    'messenger.com': 'facebook messenger',
    'whatsapp.com': 'whatsapp',
    'viber.com': 'viber',
    'discord.com': 'discord'
  }

  const searchMap = {
    'google.com': 'google',
    'bing.com': 'bing',
    'yahoo.com': 'yahoo',
    'duckduckgo.com': 'duckduckgo',
    'yandex.ru': 'yandex',
    'baidu.com': 'baidu',
    'search.ukr.net': 'ukr.net',
    'ecosia.org': 'ecosia'
  }

  for (const key in socialMap) {
    if (host.endsWith(key)) return { source: socialMap[key], medium: 'social' }
  }

  for (const key in searchMap) {
    if (host.endsWith(key)) return { source: searchMap[key], medium: 'organic' }
  }

  return { source: host, medium: 'referral' }
}

const saveUTMParams = () => {
  if (process.server) return
  const urlParams = new URLSearchParams(window.location.search)
  const utmData = {
    utm_source: urlParams.get('utm_source'),
    utm_medium: urlParams.get('utm_medium'),
    utm_campaign: urlParams.get('utm_campaign')
  }
  const isUtmSourceEmpty = !utmData.utm_source || utmData.utm_source === 'direct'
  const isUtmMediumEmpty = !utmData.utm_medium || utmData.utm_medium === 'none'
  if (
    (isUtmSourceEmpty || isUtmMediumEmpty) &&
    (urlParams.get('landing_referrer') || document.referrer)
  ) {
    const { source, medium } = detectSource(urlParams.get('landing_referrer') || document.referrer)
    utmData.utm_source = source
    if (isPaidTraffic(new URL(window.location.href)) && medium === 'social') {
      utmData.utm_medium = 'paid_social'
    } else {
      utmData.utm_medium = medium
    }
  }
  const expires = new Date(Date.now() + COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000).toUTCString()
  const options = `expires=${expires}; path=/; SameSite=Lax`
  const utm = getUTMFromCookies()
  const hasIncomingUtmParams = Object.values(utmData).some(
    value => value && value !== 'none' && value !== 'direct'
  )
  const hasUtmParamsInCookie = Object.values(utm).some(value => value)
  if (
    hasUtmParamsInCookie &&
    !urlParams.get('landing_referrer') &&
    !document.referrer &&
    !hasIncomingUtmParams
  ) {
    return
  }
  Object.entries(utmData).forEach(([key, value]) => {
    if (value) {
      document.cookie = `${key}=${encodeURIComponent(value)}; ${options}`
    }
  })
}

const getUTMFromCookies = () => {
  if (process.server) return { utm_source: '', utm_medium: '', utm_campaign: '' }
  const getCookie = name => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
    return match ? decodeURIComponent(match[2]) : null
  }
  return UTM_PARAMS.reduce((acc, param) => {
    acc[param] = getCookie(param) || ''
    return acc
  }, {})
}

const initUTMTracking = () => {
  if (process.client) saveUTMParams()
}

export { getUTMFromCookies, initUTMTracking }
